import { useState } from "react";
import { ActivityIndicator, View } from "react-native";
import { useTranslation } from "react-i18next";
import { Text } from "../common/AppText";
import { NativeButton } from "../common/NativeButton";
import { useTheme } from "../../hooks/useTheme";
import { useLocale } from "../../hooks/useLocale";
import { disclosureFields } from "../../lib/disclosure-fields";
export function EmployerDisclosurePreview({
  value,
  pending,
  unavailable,
  expanded: alwaysExpanded = false,
}: {
  value?: unknown;
  pending?: boolean;
  unavailable?: boolean;
  expanded?: boolean;
}) {
  const { t } = useTranslation("common");
  const { theme } = useTheme();
  const { isRTL } = useLocale();
  const [expanded, setExpanded] = useState(false);
  if (pending)
    return (
      <ActivityIndicator
        accessibilityLabel={t("settings.employerAccess.loading")}
      />
    );
  if (unavailable)
    return (
      <Text style={{ color: theme.textSecondary }}>
        {t("settings.employerAccess.unavailable")}
      </Text>
    );
  if (!value) return null;
  return (
    <View style={{ gap: 8 }}>
      {!alwaysExpanded ? (
        <NativeButton
          title={t(
            `settings.employerAccess.${expanded ? "hidePreview" : "showPreview"}`,
          )}
          size="sm"
          variant="outline"
          accessibilityState={{ expanded }}
          onPress={() => setExpanded(!expanded)}
        />
      ) : null}
      {alwaysExpanded || expanded ? (
        <View
          style={{
            gap: 8,
            padding: 12,
            borderWidth: 1,
            borderColor: theme.border,
            borderRadius: 12,
          }}
        >
          {disclosureFields(value).map((field) => (
            <View key={field.path}>
              <Text
                style={{
                  color: theme.textSecondary,
                  textAlign: isRTL ? "right" : "left",
                }}
              >
                {t(`settings.employerAccess.fields.${field.label}`, {
                  defaultValue: t("settings.employerAccess.fields.additional"),
                })}
              </Text>
              <Text
                selectable
                style={{
                  color: theme.text,
                  writingDirection: "auto",
                  textAlign: isRTL ? "right" : "left",
                }}
              >
                {field.photo
                  ? t("settings.employerAccess.fields.photo")
                  : field.value || t("settings.employerAccess.fields.current")}
              </Text>
            </View>
          ))}
        </View>
      ) : null}
    </View>
  );
}
